<div class="revenue-container">
  <div class="summary-cards">
    <div class="card">
      <h3>Total Geral</h3>
      <p class="value">{{ formatCurrency(revenueSummary.total) }}</p>
    </div>
    <div class="card">
      <h3>Este Mês</h3>
      <p class="value">{{ formatCurrency(revenueSummary.month) }}</p>
    </div>
    <div class="card">
      <h3>Este Ano</h3>
      <p class="value">{{ formatCurrency(revenueSummary.year) }}</p>
    </div>
  </div>

  <div class="filters">
    <label>
      De:
      <input type="date" [(ngModel)]="startDate" (change)="filterByDate()" />
    </label>
    <label>
      Até:
      <input type="date" [(ngModel)]="endDate" (change)="filterByDate()" />
    </label>
    <button (click)="filterByDate()">Filtrar</button>
  </div>

  <div class="table-wrapper">
    <table>
      <thead>
        <tr>
          <th>Data</th>
          <th>Paciente</th>
          <th>Serviço</th>
          <th>Valor</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of pagedItems">
          <td>{{ item.date }}</td>
          <td>{{ item.patient }}</td>
          <td>{{ item.service }}</td>
          <td>{{ formatCurrency(item.amount) }}</td>
        </tr>
        <tr *ngIf="pagedItems.length === 0">
          <td colspan="4" class="no-data">Nenhum registro encontrado</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="pagination">
    <button (click)="prevPage()" [disabled]="currentPage === 1">« Anterior</button>
    <button *ngFor="let pg of pages" (click)="changePage(pg)" [class.active]="pg === currentPage">
      {{ pg }}
    </button>
    <button (click)="nextPage()" [disabled]="currentPage === totalPages">Próximo »</button>
  </div>
</div>
